import { Component, computed, inject, signal } from '@angular/core';
import { SvgIconComponent } from 'angular-svg-icon';
import { Transaction } from '../../../features/services/transaction';

@Component({
  selector: 'app-transaction-timer',
  imports: [SvgIconComponent],
  templateUrl: './transaction-timer.html',
})
export class TransactionTimer {
  private transactionService = inject(Transaction);

  public transactionTimer = this.transactionService.expiryTime;

  private tick = signal<number>(Date.now());

  public expiryTimer = computed(() => {
    const expiry = this.transactionService.expiryTime();
    const now = this.tick();

    if (!expiry) return '00:00';

    const diff = new Date(expiry).getTime() - now;
    if (diff <= 0) {
      clearInterval(this.intervalId);
      return 'Payment Expired';
    }

    const minutes = Math.floor(diff / 60000);
    const seconds = Math.floor((diff % 60000) / 1000);
    return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  });

  private intervalId: any;

  ngOnInit() {
    this.intervalId = setInterval(() => {
      this.tick.set(Date.now()); // trigger recompute
    }, 1000);
  }

  ngOnDestroy() {
    clearInterval(this.intervalId);
  }
}
